import { UserPermissions } from '../data/models/user';
import store from '../data/store';

export const isAdmin = () => {
	const userPermissions = store.getState()?.authState?.user?.permissions;
	return userPermissions === UserPermissions.ADMIN.id;
};
